export const VERIFY_PHONE_REQUEST = 'VERIFY_PHONE_REQUEST' as const;
export const VERIFY_PHONE_SUCCESS = 'VERIFY_PHONE_SUCCESS' as const;
export const VERIFY_PHONE_ERROR = 'VERIFY_PHONE_ERROR' as const;
export const CLEAR_STATE_VERIFYING = 'CLEAR_STATE_VERIFYING' as const;
export const SET_ISSUCCESS_VERIFYING = 'SET_ISSUCCESS_VERIFYING' as const;
export const SET_ISSUCCESS = 'SET_ISSUCCESS' as const;
export const SET_IS_WRONG_CODE = 'SET_IS_WRONG_CODE' as const;
